
const API_URL = process.env.REACT_APP_API_URL + "settings/"

export const getAllSettingsApi = async()=>{
    let data = {}
    let response = await fetch(API_URL, {
      method: 'GET',
    })
  
    if(response.status === 200){
      data= await response.json()
    }
  
    return {
      data: data,
      status: response.status
    }
  } 

  export const UpdateSettingsApi = async (requestData) => {
    let data=null
    const token=localStorage.getItem("token")
    const response = await fetch(API_URL , {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(requestData)
    });
  
    if (response.ok) {
      data = await response.json();
    }
  
    return {
      data: data,
      status: response.status
    };
  };
  